import { typeStrategy } from "../constants/typeStrategy.constant";
import { GeoCityData, GeoData, GeoRegionData, GeoStateData } from "../types/geoGeoable";

export const geoIdentifyTypeByObject: (geo: GeoData) => keyof typeof typeStrategy = (geo: GeoData) => {
  if (!!(geo as GeoCityData).state) return 'Geo::City';
  if (!!(geo as GeoStateData).region) return 'Geo::State';
  if (!!(geo as GeoRegionData).country) return 'Geo::Region';

  return 'Geo::Country';
}

export const geoGetParentData: (geo: GeoData) => GeoData | undefined = (geo: GeoData) => {
  const geoType = geoIdentifyTypeByObject(geo);

  if (geoType === 'Geo::City') return (geo as GeoCityData).state;
  if (geoType === 'Geo::State') return (geo as GeoStateData).region;
  if (geoType === 'Geo::Region') return (geo as GeoRegionData).country;

  return undefined;
}
